/** Hub cards: Microsoft, Google, WhatsApp, OpenAI */
export const integrationHubProviders = [
  {
    id: 'microsoft',
    name: 'Microsoft',
    status: 'connected',
    lastSuccessAt: new Date(Date.now() - 3600000).toISOString(),
    ownerName: 'Sara Al Hinai',
    setupPath: 'integrations/microsoft',
    logsLabel: 'View logs',
  },
  {
    id: 'google',
    name: 'Google',
    status: 'error',
    lastSuccessAt: new Date(Date.now() - 86400000 * 5).toISOString(),
    ownerName: 'Ali Al Balushi',
    setupPath: 'integrations/google',
    logsLabel: 'View logs',
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    status: 'connected',
    lastSuccessAt: new Date(Date.now() - 7200000).toISOString(),
    ownerName: 'Ops Bot',
    setupPath: 'integrations/whatsapp',
    logsLabel: 'View logs',
  },
  {
    id: 'openai',
    name: 'OpenAI',
    status: 'pending',
    lastSuccessAt: null,
    ownerName: '—',
    setupPath: 'integrations',
    logsLabel: 'View logs',
  },
];

export const integrationSetupChecklists = {
  microsoft: [
    { id: 'm1', label: 'Azure app registration', done: true },
    { id: 'm2', label: 'Admin consent', done: true },
    { id: 'm3', label: 'Teams app manifest', done: true },
    { id: 'm4', label: 'Webhook subscriptions', done: false },
    { id: 'm5', label: 'Test booking', done: false },
  ],
  google: [
    { id: 'g1', label: 'OAuth client', done: false },
    { id: 'g2', label: 'Calendar API', done: false },
    { id: 'g3', label: 'Domain-wide delegation', done: false },
    { id: 'g4', label: 'User sync', done: false },
    { id: 'g5', label: 'Meet artifacts', done: false },
  ],
  whatsapp: [
    { id: 'w1', label: 'Meta Business', done: true },
    { id: 'w2', label: 'Phone number', done: true },
    { id: 'w3', label: 'Webhook', done: true },
    { id: 'w4', label: 'Templates', done: false },
    { id: 'w5', label: 'Quality rating', done: true },
  ],
  openai: [
    { id: 'o1', label: 'API key', done: false },
    { id: 'o2', label: 'Model routing', done: false },
    { id: 'o3', label: 'Data residency', done: false },
    { id: 'o4', label: 'Usage limits', done: false },
    { id: 'o5', label: 'Safety filters', done: false },
  ],
};

/** Legacy shape */
export const integrationHub = {
  microsoft: { connected: true, tenantId: 'contoso.onmicrosoft.com', lastHealthCheck: new Date().toISOString() },
  google: { connected: false, reason: 'not_configured' },
  whatsapp: { connected: true, phoneNumberId: 'PN-8821', qualityRating: 'GREEN' },
};

export const microsoftSetupState = {
  currentStep: 1,
  credentials: {
    tenantId: '',
    clientId: '',
    clientSecret: '',
    saved: false,
  },
  consent: {
    graphStatus: 'partial',
    verifiedAt: new Date(Date.now() - 86400000).toISOString(),
    scopes: [
      { name: 'Calendars.ReadWrite', granted: true },
      { name: 'OnlineMeetings.ReadWrite', granted: true },
      { name: 'User.Read.All', granted: false },
    ],
  },
  teamsApp: {
    uploadStatus: 'not_uploaded',
  },
  testBooking: {
    lastRunAt: null,
    success: null,
    message: '',
  },
};

export const microsoftSetupSteps = [
  { id: 'ms-1', label: 'Grant admin consent', done: true },
  { id: 'ms-2', label: 'Register Teams app', done: true },
  { id: 'ms-3', label: 'Subscribe to calendar webhooks', done: true },
  { id: 'ms-4', label: 'Deploy bot to tenant', done: false },
];

export const googleSetupState = {
  currentStep: 1,
  connected: true,
  accountEmail: 'workspace-admin@acme.example',
  tokenExpiresAt: new Date(Date.now() + 86400000 * 5).toISOString(),
  scopes: [
    { name: 'calendar', granted: true },
    { name: 'directory.readonly', granted: true },
    { name: 'meetings.read', granted: false },
  ],
  calendarTest: { lastAt: new Date(Date.now() - 86400000).toISOString(), success: true },
  userSync: { lastAt: new Date(Date.now() - 3600000).toISOString(), count: 142, scope: 'all_org' },
  meetArtifact: { lastSample: 'Sample transcript excerpt…', ok: true },
};

export const googleSetupSteps = [
  { id: 'gg-1', label: 'Create OAuth client', done: true },
  { id: 'gg-2', label: 'Enable Calendar API', done: true },
  { id: 'gg-3', label: 'Configure domain-wide delegation', done: false },
];

export const whatsappSetupState = {
  blocks: [
    { id: 'ba', title: 'Business Account', status: 'ok', detail: 'WABA-9912 verified', action: 'View' },
    { id: 'pn', title: 'Phone Number', status: 'ok', detail: '+968 7000 1234', action: 'Manage' },
    { id: 'wh', title: 'Webhook', status: 'error', detail: 'Signature mismatch (mock)', action: 'Re-verify' },
    { id: 'tp', title: 'Templates', status: 'ok', detail: '3 approved', action: 'Create' },
  ],
  webhookUrl: 'https://api.meetinghub.ai/hooks/whatsapp/acme-tenant',
  webhookVerified: false,
  templates: [
    { id: 't1', name: 'booking_confirm', status: 'APPROVED' },
    { id: 't2', name: 'reminder_1h', status: 'APPROVED' },
    { id: 't3', name: 'mom_ready', status: 'APPROVED' },
  ],
  checklistStep: 2,
};

export const whatsappSetupStatus = {
  businessAccountId: 'WABA-9912',
  displayPhone: '+968 7000 1234',
  webhookVerified: true,
  templateNamespace: 'meetinghub_v1',
};
